<template>
  <div>
    <c-row>
      <c-col col="12">
        <c-card>
          <c-card-header>
            <strong>Debt</strong>
            <div class="card-header-actions">
              <CInput @keyup="doSearch" type="text" placeholder="Ketikan sesuatu kemudian tekan enter" v-model="q"
                style="width: 400px" ref="search"></CInput>
            </div>
          </c-card-header>
          <c-card-body style="overflow: auto">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th width="50px">No</th>
                  <th>Faktur</th>
                  <th>Pelanggan</th>
                  <th>Total</th>
                  <th>Jatuh Tempo</th>
                  <th>Faktur</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in data.data" :key="k">
                  <td class="center">
                    <table-number :index="k" :paginate="data.paginate" />
                  </td>
                  <td>{{ d.faktur }}</td>
                  <td>{{ d.customer_name }}</td>
                  <td align="right">{{ d.total | thousandSeparator }}</td>
                  <td align="right">{{ d.period | dateFormat }}</td>
                  <td>{{ d.faktur }}</td>
                  <td align="center">
                    <label class="label bg-warning" v-if="d.status != 0">Belum Lunas</label>
                    <label class="label bg-success" v-if="d.status == 0">Lunas</label>
                  </td>
                  <td align="center">
                    <CButton class="btn-outline-info btn btn-action" v-c-tooltip.hover.click="'Bayar'"
                      @click="doEdit(d.id)">
                      <i class="cil-money"></i>
                    </CButton>
                  </td>
                </tr>
              </tbody>
            </table>
          </c-card-body>
          <c-card-footer>
            <Paginator :paginator="data.paginate" @change="changePage" />
          </c-card-footer>
        </c-card>
      </c-col>
    </c-row>
  </div>
</template>
<script>
import Paginator from '../../components/Paginator.vue';
import TableNumber from "../../components/TableNumber2";
import { HTTPAUTH } from "../../lib/httplib";

export default {
  name: "CardList",
  components: {
    TableNumber,
    Paginator
  },
  data () {
    return {
      currentPage: 1,
      total: 1,
      data: {},
      q: "",
      dataUrl: "/api/v1/receivable",
      dataSize: 10
    };
  },
  created () {
    const query = this.$route.query;
    if (query.q) {
      this.loadData(1, query.q);
      this.q = query.q;
      return;
    }
    this.loadData(1, "");
  },
  methods: {
    loadData (page, q) {
      this.currentPage = page;
      HTTPAUTH.get(
        this.dataUrl + `?q=${q}&page=${page}&size=${this.dataSize}`
      ).then(res => {
        const paginate = res.data.paginate;
        this.total = paginate.total;
        this.data = res.data;
      });
    },
    doSearch (e) {
      if (e.keyCode === 13) {
        this.loadData(1, this.q);
        this.$router.push({ query: { search: true, q: this.q } });
      }
    },
    doEdit (id) {
      this.$router.push({ path: "/j/receivable/" + id });
    },
    changePage (page) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.loadData(page, q);
    }
  },
  watch: {
    currentPage (pageNext) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.loadData(pageNext, q);
    }
  }
};
</script>